import { useCallback, useState } from 'react'
import { ListOption } from '../organisms/list/list-option/list-option.type'

export const useDropdownFocus = (options: ListOption[]) => {
  const [focusedOptionIndex, setFocusedOptionIndex] = useState(0)

  const moveFocusDown = useCallback(() => {
    const lastOptionIndex = options.length - 1
    const focusIndex = focusedOptionIndex < lastOptionIndex ? focusedOptionIndex + 1 : 0
    setFocusedOptionIndex(focusIndex)
  }, [options.length, focusedOptionIndex])

  const moveFocusUp = useCallback(() => {
    const focusIndex = focusedOptionIndex > 0 ? focusedOptionIndex - 1 : options.length - 1
    setFocusedOptionIndex(focusIndex)
  }, [options.length, focusedOptionIndex])

  return { focusedOptionIndex, setFocusedOptionIndex, moveFocusUp, moveFocusDown }
}
